import React, { HTMLAttributes } from 'react';
import classnames from 'classnames';
import { gikClassPrefix } from '@gik/core/constants';
import FontIcon from '../FontIcon';

export interface CollapseProps extends HTMLAttributes<HTMLElement> {
  open?: boolean;
  defaultOpen?: boolean;
  title: string;
  visibleTitle?: string;
}

const blockName = `${gikClassPrefix}-collapse`;

export default function Collapse({
  className,
  children,
  open,
  defaultOpen = false,
  onClick,
  title,
  visibleTitle,
  ...otherProps
}: CollapseProps): React.ReactElement {
  const controlled = open !== undefined;

  const [isOpen, setIsOpen] = React.useState(defaultOpen);
  const blockClasses = classnames([blockName, className || '']);

  function handleHeaderClick(ev: React.MouseEvent<HTMLDivElement>) {
    if (onClick) onClick(ev);
    if (!controlled) setIsOpen(!isOpen);
  }

  return (
    <div className={blockClasses} {...otherProps}>
      <header onClick={handleHeaderClick}>
        {isOpen && (
          <span className={`${blockName}__title`}>
            <FontIcon name="chevronDown" size="sm" /> {visibleTitle || title}
          </span>
        )}
        {!isOpen && (
          <span className={`${blockName}__title`}>
            <FontIcon name="chevronRight" size="sm" /> {title}
          </span>
        )}
      </header>
      {isOpen && <main>{children}</main>}
    </div>
  );
}
